import { render, staticRenderFns } from "./removeBookingForm.vue?vue&type=template&id=477ac9ee&"
import script from "./removeBookingForm.vue?vue&type=script&lang=js&"
export * from "./removeBookingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports